import { render } from "./Calenders.vue?vue&type=template&id=e54bd0de"
import script from "./Calenders.vue?vue&type=script&lang=js"
export * from "./Calenders.vue?vue&type=script&lang=js"

import "./Calenders.vue?vue&type=style&index=0&id=e54bd0de&lang=css"

import exportComponent from "C:\\Users\\Ibrahim\\Documents\\uat-frontend-saxton\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__